import React from 'react';
import { FormTreeData, VisibilityChangeCallback } from './types';
import { FormGroup } from './FormGroup';

export interface FormRendererProps {
  formTree: FormTreeData[];
  depth?: number;
  disabled?: boolean;
  onVisibilityChange?: VisibilityChangeCallback;
}

const FormRenderer: React.FC<FormRendererProps> = ({
  formTree,
  depth = 0,
  disabled,
  onVisibilityChange,
}) => {
  return (
    <div className={`${depth === 0 ? 'space-y-12' : 'space-y-8'}`}>
      {formTree.map(node => (
        <FormGroup
          key={node.id}
          node={node}
          depth={depth}
          disabled={disabled}
          onVisibilityChange={onVisibilityChange}
        />
      ))}
    </div>
  );
};

export default FormRenderer;
